import { motion } from "framer-motion";
import { useEffect } from "react";


const steps = [
  { title: "Scope", icon: "📋" },
  { title: "Strategy", icon: "🧠" },
  { title: "Collection", icon: "📦" },
  { title: "Annotation & QA", icon: "✅" },
  { title: "Delivery", icon: "🚚" },
  { title: "Support", icon: "💬" }
];

export default function Workflow() {
  // useEffect(() => {
  //       window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  //     }, []);
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-black via-gray-900 to-black text-white">
      <div className="max-w-5xl mx-auto text-center">
        {/* Main Heading */}
        <h2 className="text-4xl font-extrabold mb-16 text-white font-orbitron tracking-tight">
          Our Workflow
        </h2>

        {/* Steps Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-12 place-items-center">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.1 }}
              className="flex flex-col items-center gap-4 cursor-pointer"
            >
              {/* Circular Icon */}
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-indigo-500 bg-gradient-to-br from-indigo-600 to-indigo-400 text-white text-3xl font-bold shadow-lg transition duration-300">
                {step.icon}
              </div>

              {/* Step Title */}
              <p className="text-white font-semibold text-lg text-center">
                {step.title}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
